module.exports = __webpack_public_path__ + "img/event-sample.fbd152f5.svg";